// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2MWHj","header":"PatientQuestionnaire_header__MMqIu","info":"PatientQuestionnaire_info__3OY0U"};